import React, { Component } from "react";
import spire_logo from '../imgs/logos/spire_logo.png'
import iisc_logo from '../imgs/logos/iisc_logo.png'
import nimhans_logo from '../imgs/logos/nimhans_logo.jpg'

class NavBar extends Component {
  render() {
    return (
      <div className="mb-2" >
        <div className="d-flex">
            <div classname="flex-row">
	          <div className="mr-auto" style={{ display: 'inline-block', top: "500px" }}>
	            <a href="https://spire.ee.iisc.ac.in/spire/" >
	              <img className="nav-link" src={spire_logo} alt="spire_logo" style={{ maxHeight: 100 }}></img>
	            </a>
	          </div>
	          <div className="mr-auto" style={{ display: 'inline-block'}}>
	            <a href="https://nimhans.ac.in/" >
	              <img className="nav-link" src={nimhans_logo} alt="nimhans_logo" style={{ maxHeight: 100 }}></img>
	            </a>
	          </div>
	        </div>
          <div className="ml-auto" style={{ display: 'inline-block' }}>
            <a href="https://www.iisc.ac.in/" >
              <img className="nav-link" src={iisc_logo} alt="iisc_logo" style={{ maxHeight: 100, position: { top: -20 } }}></img>
            </a>
          </div>
        </div>
        <nav className="navbar navbar-expand-sm navbar-light bg-light">
          <div className="navbar-collapse">
            <ul className="navbar-nav mr-auto">
              <li className="navbar-nav">

              </li>
              <li className="navbar-nav">
                <button
                  className="nav-link"
                  onClick={() => this.props.setCurrentPage("home")}
                >
                  Home
                </button>
              </li>
              <li className="navbar-nav">
                <button
                  className="nav-link"
                  onClick={() => this.props.setCurrentPage("about")}
                >
                  About
                </button>
              </li>
              <li className="navbar-nav">
                <button
                  className="nav-link"
                  onClick={() => this.props.setCurrentPage("contact")}
                >
                  Contact
                </button>
              </li>
              <li className="navbar-nav">
                <button
                  className="nav-link"
                  onClick={() => this.props.setCurrentPage("terms")}
                >
                  Start Recording
                </button>
              </li>
            </ul>
            <ul className="navbar-nav ml-auto">
              <li
                className="navbar-nav"
                style={{
                  display:
                    this.props.appState.isLoggedIn === false ? "block" : "none",
                }}
              >
                <button
                  type="button"
                  className="nav-link"
                  onClick={this.props.login}
                >
                  Login
                </button>
              </li>
              <li
                className="navbar-nav"
                style={{
                  display:
                    this.props.appState.isLoggedIn === true ? "block" : "none",
                }}
              >
                <button className="nav-link" onClick={this.props.logout}>
                  Logout
                </button>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    );
  }
}

export default NavBar;
